export default __webpack_public_path__ + "static/media/default.18df4272.svg";